import React from 'react';
import { Drawer } from '@mui/material';
import useMobileMenu from '../../../../../hooks/useMobileMenu';
import { MobileNavigationItemWrapper } from './MobileNavigationItemWrapper';
import { SIDEBAR_QUOTATION_NAVIGATION } from '../../../../../utils/constans/SidebarMenu';

export const QuotationMobileDrawer = () => {
    const mobileMenu = useMobileMenu();

    const toggleDrawer =
        (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
            if (
                event.type === 'keydown' &&
                ((event as React.KeyboardEvent).key === 'Tab' ||
                    (event as React.KeyboardEvent).key === 'Shift')
            ) {
                return;
            }

            mobileMenu.showQuotationMenu(open);
        };

    return (
        <>
            <Drawer
                anchor={'right'}
                open={mobileMenu.mobileMenuStates.quotation.open}
                onClose={toggleDrawer(false)}
            >
                <MobileNavigationItemWrapper
                    menuItems={SIDEBAR_QUOTATION_NAVIGATION}
                />
            </Drawer>
        </>
    );
};
